export function formatNumber(num?: any, digits = 2) {
  if (typeof num === "string" && num.trim() !== "") {
    num = Number(num);
  }
  if (typeof num !== "number" || !isFinite(num)) {
    return "";
  } else {
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
  }
}

export function formatMoney(amountObj?: any, useDollars?: any, digits = 2) {
  let amount = useDollars ? amountObj.usd : amountObj.pen;
  if (typeof amount === "string" && amount.trim() !== "") {
    amount = Number(amount);
  }
  if (typeof amount !== "number" || !isFinite(amount)) {
    return "";
  } else {
    const amountStr = Number(amount).toLocaleString("en-US", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });

    return `${useDollars ? "$ " : "S/ "}${amountStr}`;
  }
}

export function formatMoneyNumber(amountObj?: any, useDollars?: any): any {
  let amount: any = useDollars ? amountObj.usd : amountObj.pen;
  if (typeof amount === "string" && amount.trim() !== "") {
    amount = Number(amount);
  }
  if (typeof amount !== "number" || !isFinite(amount)) {
    return "";
  }

  return amount;
}

export function formatMoneyInput(amount?: any, useDollars?: any, digits = 2) {
  if (typeof amount === "string" && amount.trim() !== "") {
    amount = Number(amount);
  }
  if (typeof amount !== "number" || !isFinite(amount)) {
    return "";
  } else {
    const amountStr: any = Number(amount).toLocaleString("en-US", {
      maximumFractionDigits: digits,
    });

    return `${useDollars ? "$" : "S/"}${amountStr}`;
  }
}
